function getJsonFromUrl(url, useMultipleKeys = false) {
  if (!url) url = location.href;
  var question = url.indexOf('?');
  var hash = url.indexOf('#');
  if (hash == -1 && question == -1) return {};
  if (hash == -1) hash = url.length;
  var query = question == -1 || hash == question + 1 ? url.substring(hash) : url.substring(question + 1, hash);
  var result = {};
  query.split('&').forEach(function (part) {
    if (!part) return;
    part = part.split('+').join(' '); // replace every + with space, regexp-free version
    var eq = part.indexOf('=');
    var key = eq > -1 ? part.substr(0, eq) : part;
    var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : '';
    var from = key.indexOf('[');
    if (from == -1) {
      var k = decodeURIComponent(key);
      if (useMultipleKeys) {
        result[k] = result[k] || [];
        result[k].push(val);
      } else {
        result[k] = val;
      }
    } else {
      var to = key.indexOf(']', from);
      var index = decodeURIComponent(key.substring(from + 1, to));
      key = decodeURIComponent(key.substring(0, from));
      if (!result[key]) result[key] = [];
      if (!index) result[key].push(val);
      else result[key][index] = val;
    }
  });
  return result;
}

// function getVimeoVideoId(url) {
//   if (!url) {
//     return '';
//   }
//   return url.match(
//     /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/i,
//   )?.[3];
// }

function getYoutubeVideoId(url) {
  if (!url) {
    return '';
  }

  url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
}

window.storeTheme = window.storeTheme || ({} as StoreTheme);

Object.assign(window.storeTheme, {
  helpers: Object.assign(window.storeTheme.helpers || {}, {
    url: {
      getJsonFromUrl,
      getVideoIdFromUrl: getYoutubeVideoId,
    },
  }),
});

export default {};
